export default "<!--component html goes here -->\n"